import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function FeatureSection({ feature }) {
    const [iconSize, setIconSize] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [headingSize, setHeadingSize] = useState(0);
    const [headingHeight, setHeadingHeight] = useState(0);
    const [gap, setGap] = useState(0);

    useEffect(() => {
        setIconSize((zoomSize/100)*28);

        setHeadingSize((zoomSize/100)*16);
        setHeadingHeight((zoomSize/100)*26);

        setGap((zoomSize/100)*12);
    }, [zoomSize]);

    return (
        <div style={{ gap: `${gap}px` }} className="flex flex-col items-center">
            <div style={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                <img className='size-full' src={feature?.imageLink} alt={feature.altText} />
            </div>

            <h1 style={{ fontSize: `${headingSize}px`, lineHeight: `${headingHeight}px` }} className='font-semibold text-[#212121]'>{feature.Heading}</h1>
        </div>
    )
}

function FeaturesTwo({ item }) {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [gap, setGap] = useState(0);
    const [paddingSide, setPaddingSide] = useState(0);

    useEffect(() => {
        setGap((zoomSize/100)*20);
        setPaddingSide((zoomSize/100)*16);
    }, [zoomSize]);

    return (
        <div 
            style={{ gap: `${gap}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} 
            className='w-full flex flex-col relative'
        >
            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesTwo;
